import { validateCompanyId } from "../../services/registroApi";
import { sendMail } from "../../services/emailApi";
import { store } from "../../config/store";
import apiConfig from "../../config/api";

import { getParametersListByName } from "../../services/listasApi";

import trace from "../../helpers/trace";
import { fullScreenLoading } from "../Acceso/Login/actions";
import constants from "../../helpers/constants";
import { GetCompanyValidOffices } from "../../services/datosEmpresa";
import { sendSMSActivationAccount } from "../Acceso/Registro/actions";
export const ActualizarDatosUsuario = (userData) => ({
  type: "GLOBAL_ACTUALIZAR_DATOS_USUARIO",
  userData,
});

export const openCloseTour = (isOpen) => ({
  type: "OPEN_CLOSE_TOUR",
  isOpen,
});

export const setUserProfile = (profile) => ({
  type: "SET_USER_PROFILE",
  profile,
});

export const openCloseTourConfirmation = (isOpen) => ({
  type: "OPEN_CLOSE_TOUR_CONFIRMATION",
  isOpen,
});

export const setExpanded = (expand) => ({
  type: "SET_EXPANDED",
  expand,
});

export const openCloseToast = (toast) => ({
  type: "OPEN_CLOSE_TOAST",
  toast,
});
export const loading = (isLoading) => ({
  type: "LOADING",
  isLoading,
});

export const setSelectedCompany = (companyId, companyName) => ({
  type: "SET_SELECTED_COMPANY",
  companyId,
  companyName,
});
export const setSucursalId = (sucursalId, sucursalName) => ({
  type: "SET_SUCURSALID",
  sucursalId,
  sucursalName,
});
export const setComanyList = (listaEmpresas) => ({
  type: "SET_COMPANY_LIST",
  listaEmpresas,
});

export const setRegionesList = (listaRegiones) => ({
  type: "SET_REGIONES_LIST",
  listaRegiones,
});

export const setComunasCiudadesList = (listaRegiones) => ({
  type: "SET_REGIONES_LIST",
  listaRegiones,
});

export const setColor = (botomBorderColor) => ({
  type: "SET_COLOR",
  botomBorderColor,
});

export const setUserFunctionalities = (ids) => ({
  type: "SET_USER_FUNCTIONALITIES",
  ids,
});

export const setPreventNavigation = (preventNavigation) => ({
  type: "SET_PREVENT_NAVIGATION",
  preventNavigation,
});

export const setAllList = (list) => ({
  type: "SET_ALL_LIST",
  list,
});

export const setComunasbyRegionList = (comunas) => ({
  type: "SET_COMUNAS_BY_REGION_LIST",
  comunas,
});

export const setSucursalesList = (list) => ({
  type: "SET_SUCURSALES_LIST",
  list,
});

export const setSucursalesOfCompany = (list) => ({
  type: "SET_SUCURSALES_OF_COMPANY",
  list,
});

export const resetGlobalState = () => ({
  type: "RESET_GLOBAL_STATE",
});

export const setUserAccessList = (list) => ({
  type: "SET_USER_ACCESS_LIST",
  list,
});

export const doFindCompanies = (RutUser) => async (dispatch) => {
  dispatch(loading(true));
  try {
    let resultRut;

    const response = await validateCompanyId(RutUser);
    if (response.ok) {
      resultRut = await response.json();
      if (resultRut.Success === true && resultRut.Companies !== null) {
        dispatch(setComanyList(resultRut.Companies));
      }
    } else {
      trace.information("ERROR", "Sin Empresas");
    }
  } catch (error) {
    trace.information("ERROR", error);
    dispatch(
      openCloseToast({
        isToastOpen: true,
        msgToast: "Error de conexión, intente más tarde",
        typeStyle: "error",
        displayTime: 5000
      })
    );
  }
  dispatch(loading(false));
};

export const getFunctionalitiesForCompany = (companyId) => async (dispatch) => {
  try {
    const { userAccessList } = store.getState().global;
    const ids = [];
    if (Array.isArray(userAccessList)) {
      userAccessList
        .filter((i) => i.ProfileCode === constants.codePerfilTrabajador)
        .forEach((func) => {
          ids.push(func.Code.trim());
        });

      userAccessList
        .filter((i) => i.CompanyId?.toLowerCase() === companyId?.toLowerCase())
        .forEach((func) => {
          ids.push(func.Code.trim());
        });
      dispatch(setUserFunctionalities(ids));
    }
    dispatch(fullScreenLoading(false));
  } catch (error) {
    dispatch(fullScreenLoading(false));
    trace.error("ERROR getFunctionalitiesForCompany", error);
    dispatch(
      openCloseToast({
        isToastOpen: true,
        msgToast: "Error al obtener las funcionalidades de la empresa",
        typeStyle: "error",
        displayTime: 5000
      })
    );
  }
};

export const setCompanyId = (
  companyId,
  companyName,
  closeSelectCallback = () => {}
) => async (dispatch) => {
  try {
    dispatch(fullScreenLoading(true));
    let list = [];
    dispatch(setSelectedCompany(companyId, companyName));
    const rutCompany = localStorage.getItem('rutEnterprise') ?? companyId;
    const request = await GetCompanyValidOffices(rutCompany);
    if (request.status === 200) {
      const result = await request.json();
      list = [...result];
    }
    closeSelectCallback();
    dispatch(getFunctionalitiesForCompany(companyId));
    dispatch(setSucursalesOfCompany(list));
  } catch (error) {
    trace.error("setCompanyId", error);
    dispatch(
      openCloseToast({
        isToastOpen: true,
        msgToast: "Error de conexión, intente más tarde",
        typeStyle: "error",
        displayTime: 5000
      })
    );
  }
};

export const getLists = (listas) => async (dispatch) => {
  try {
    const listGlobal = store.getState().global;
    const result = {};
    const parameters = await getParametersListByName(listas);
    const response = await parameters.json();

    Object.keys(response).forEach((prop) => {
      switch (prop) {
        case "ListaProfesiones": {
          result.listaProfesiones =
            response[prop] && response[prop].Success
              ? response[prop].ListaOcupaciones
              : listGlobal.listaProfesiones;
          break;
        }
        case "ListaIsapres": {
          result.listaIsapres =
            response[prop] && response[prop].Success
              ? response[prop].ListaIsapres
              : listGlobal.listaIsapres;
          break;
        }
        case "ListaAfp": {
          result.listaAfp =
            response[prop] && response[prop].Success
              ? response[prop].ListadoAfps
              : listGlobal.listaAfp;
          break;
        }
        case "ListaRegion": {
          result.listaRegion =
            response[prop] && response[prop].Success
              ? response[prop].Regiones
              : listGlobal.listaRegion;
          break;
        }
        case "ListaEstadoCivil": {
          result.listaEstadoCivil =
            response[prop] && response[prop].Success
              ? response[prop].EstadosCiviles
              : listGlobal.listaEstadoCivil;
          break;
        }
        case "ListaBancos": {
          result.listaBancos =
            response[prop] && response[prop].Success
              ? response[prop].ListaBancos
              : listGlobal.listaBancos;
          break;
        }
        case "ListaTipoJornada": {
          result.listaTipoJornada =
            response[prop] && response[prop].Success
              ? response[prop].ListaJornadas
              : listGlobal.listaTipoJornada;
          break;
        }
        case "ListaRubro": {
          result.listaRubro =
            response[prop] && response[prop].Success
              ? response[prop].ListaRubros
              : listGlobal.listaRubro;
          break;
        }
        case "ListaParentesco": {
          result.listaParentesco =
            response[prop] && response[prop].Success
              ? response[prop].ListaParentescos
              : listGlobal.listaParentesco;
          break;
        }
        case "ListaComuna": {
          result.listaComuna =
            response[prop] && response[prop].Success
              ? response[prop].Comunas
              : listGlobal.listaComuna;
          break;
        }
        case "ListadoSucursales": {
          result.listadoSucursales =
            response[prop] && response[prop].Success
              ? response[prop].Sucursales
              : listGlobal.listadoSucursales;
          break;
        }
        case "ListaSexos": {
          result.listaSexos =
            response[prop] && response[prop].Success
              ? response[prop].ListaSexos
              : listGlobal.listaSexos;
          break;
        }
        case "ListaNacionalidades": {
          const listaNacionalidades =
            response[prop] && response[prop].Success
              ? response[prop].ListaNacionalidades
              : listGlobal.listaNacionalidades;

          result.listaNacionalidades = listaNacionalidades.map((obj) => {
            obj.Nacionalidad =
              obj.Nacionalidad.charAt(0).toUpperCase() +
              obj.Nacionalidad.slice(1);
            return obj;
          });

          break;
        }
        case "ListaPueblosOriginarios": {
          result.listaPueblosOriginarios =
            response[prop] && response[prop].Success
              ? response[prop].ListaPueblosOriginarios
              : listGlobal.listaPueblosOriginarios;
          break;
        }
        case "ListaTiposCalle": {
          result.listaTiposCalle =
            response[prop] && response[prop].Success
              ? response[prop].ListaTiposCalle
              : listGlobal.listaTiposCalle;
          break;
        }
        case "ListaClasificacionesAccidentes": {
          result.listaClasificacionesAccidentes =
            response[prop] && response[prop].Success
              ? response[prop].ListaClasificacionesAccidente
              : listGlobal.listaClasificacionesAccidentes;
          break;
        }
        case "ListaMediosPrueba": {
          result.listaMediosPrueba =
            response[prop] && response[prop].Success
              ? response[prop].ListaMediosPrueba
              : listGlobal.listaMediosPrueba;
          break;
        }
        case "ListaTiposCuenta": {
          result.listaTiposCuenta =
            response[prop] && response[prop].Success
              ? response[prop].ListaTipoCuentas
              : listGlobal.listaTiposCuenta;
          break;
        }
        case "ListaTiposContrato": {
          result.listaTiposContrato =
            response[prop] && response[prop].Success
              ? response[prop].ListaTiposContrato
              : listGlobal.listaTiposContrato;
          break;
        }
        case "ListaCategoriasOcupacionales": {
          result.listaCategoriasOcupacionales =
            response[prop] && response[prop].Success
              ? response[prop].ListaCategoriasOcupacionales
              : listGlobal.listaCategoriasOcupacionales;
          break;
        }
        case "ListaTiposIngreso": {
          result.listaTiposIngreso =
            response[prop] && response[prop].Success
              ? response[prop].ListaTiposIngreso
              : listGlobal.listaTiposIngreso;
          break;
        }
        case "ListaDirecciones": {
          result.listaDirecciones =
            response[prop] && response[prop].Success
              ? response[prop].ListadoDirecciones
              : listGlobal.listaDirecciones;
          break;
        }
        case "ListaTiposDenuncia": {
          result.listaTipoDenuncias =
            response[prop] && response[prop].Success
              ? response[prop].ListaTiposDenuncia
              : listGlobal.listaTipoDenuncias;
          break;
        }
        case "ListaTiposEmpresa": {
          result.listaTipoEmpresa =
            response[prop] && response[prop].Success
              ? response[prop].ListaTiposEmpresa
              : listGlobal.listaTipoEmpresa;
          break;
        }
        case "ListaActividadEconomica": {
          result.listaActividadEconomica =
            response[prop] && response[prop].Success
              ? response[prop].ListaActividadEconomica
              : listGlobal.listaActividadEconomica;
          break;
        }
        case "ListaPropiedadEmpresa": {
          result.listaPropiedadEmpresa =
            response[prop] && response[prop].Success
              ? response[prop].ListaPropiedadEmpresa
              : listGlobal.listaPropiedadEmpresa;
          break;
        }
        case "ListaTiposAccidenteTrayecto": {
          result.listaTiposAccidenteTrayecto =
            response[prop] && response[prop].Success
              ? response[prop].ListaTiposAccidenteTrayecto
              : listGlobal.listaTiposAccidenteTrayecto;
          break;
        }
        case "ListaTiposAccidente": {
          result.listaTiposAccidente =
            response[prop] && response[prop].Success
              ? response[prop].ListaTiposAccidente
              : listGlobal.listaTiposAccidente;
          break;
        }
        default: {
          break;
        }
      }
    });

    dispatch(setAllList(result));
  } catch (error) {
    trace.error("getLists", error);
    dispatch(
      openCloseToast({
        isToastOpen: true,
        msgToast: "Error de conexión, intente más tarde",
        typeStyle: "error",
        displayTime: 5000
      })
    );
  }
};

export const getSucursales = (companyId) => async (dispatch) => {
  dispatch(loading(true));
  try {
    const result = {};

    const rutCompany = localStorage.getItem('rutEnterprise') ?? companyId;
    const response = await GetCompanyValidOffices(rutCompany);
    if (response.status === 200) {
      const resultResponse = await response.json();
      result.listadoSucursales = resultResponse;
    } else {
      result.listadoSucursales = [];
    }
    dispatch(setSucursalesList(result.listadoSucursales));
  } catch (error) {
    trace.error("getSucursales", error);
    dispatch(
      openCloseToast({
        isToastOpen: true,
        msgToast: "Error de conexión, intente más tarde",
        typeStyle: "error",
        displayTime: 5000
      })
    );
  }
  dispatch(loading(false));
};

export const mailPrmts = (parameters) => {
  const result = {};
  let subject = "";
  let dynamic_template_data = {};
  result.from = {
    email: "automatizacion@achs.cl",
    name: "Asociacion Chilena de Seguridad",
  };
  switch (parameters.templateMail) {
    case "bienvenidaTemporal": {
      result.template_id = "d-700dbc5491bf4a68b1b908d6e54aa072";
      subject = "Bienvenido a ACHS";

      dynamic_template_data = {
        NombreApellido: `${parameters.userInfo.FirstName} ${
          parameters.userInfo.LastName ? parameters.userInfo.LastName : " "
        }`,
        RutEmpresa: parameters.userInfo.rutEmpresa,
        RutPersona: parameters.userInfo.Rut,
        EmailPersona: parameters.userInfo.Email,
        UrlAchs: parameters.buttonUrl,
      };
      break;
    }
    case "activaUsuario": {
      result.template_id = "d-802a4240439543d2815e5b13e5f28277";
      subject = "Activar Cuenta";
      dynamic_template_data = {
        NombreApellido: `${parameters.userInfo.FirstName} ${
          parameters.userInfo.LastName ? parameters.userInfo.LastName : " "
        }`,
        rut: parameters.userInfo.Rut,
        mail: parameters.userInfo.Email,
        urlActivacion: parameters.userInfo.href,
      };
      break;
    }
    case "solicitudRechazada": {
      result.template_id = "d-ed2338e1ec0b40ea95e30ac37134d9b8";
      subject = "Solicitud Rechazada";
      dynamic_template_data = {
        NombreApellido: `${parameters.userInfo.FirstName} ${
          parameters.userInfo.LastName ? parameters.userInfo.LastName : " "
        }`,
        empresa: parameters.userInfo.NombreEmpresa,
        UrlAchs: apiConfig.urlLink,
      };
      break;
    }
    case "solicitudAprobada": {
      result.template_id = "d-307f36daaca94177b9f8b0e8f021de6c";
      subject = "Solicitud Aprobada";
      dynamic_template_data = {
        NombreApellido: `${parameters.userInfo.FirstName} ${
          parameters.userInfo.LastName ? parameters.userInfo.LastName : " "
        }`,
        empresa: parameters.userInfo.NombreEmpresa,
        UrlAchs: apiConfig.urlLink,
      };
      break;
    }
    default: {
      break;
    }
  }

  result.personalizations = [
    {
      to: [
        {
          email: parameters.userInfo.Email,
          name: `${
            parameters.userInfo.FirstName ? parameters.userInfo.FirstName : null
          } ${
            parameters.userInfo.LastName ? parameters.userInfo.LastName : null
          }`,
        },
      ],
      subject,
      dynamic_template_data,
    },
  ];
  result.reply_to = {
    email: "automatizacion@achs.cl",
    name: "Asociacion Chilena de Seguridad",
  };

  return result;
};
/**
 * Metodo encargado de ejecutar envio de correo de activación
 * de cuenta a los usuarios
 * @param {*} parameters : Recibe los parametros del correo
 * @param {*} showtoast: Indica si debe mostrar el toast de notificacion
 */
export const sendEmailApp = (parameters, showtoast = true) => async (
  dispatch,
  getState
) => {
  //Setea los parametros del correo del email asi como el template
  const json = mailPrmts(parameters);
  const toast = {};
  /**
   * Obtener el state desde redux para recuperar los datos de telefono y link correo
   * desde el el store de redux
   */
  // const { userRegister } = getState();
  // const {
  //   mailActivationAdParams: {
  //     userInfo: { href: urlCorreo },
  //   },
  // } = userRegister;
  // const {
  //   UserInfo: { Phone },
  // } = userRegister;
  //
  // //Objeto con los datos para el envio de sms
  // const datosSMSMesssage = {
  //   urlCorreo,
  //   Phone,
  // };

  /**
   * Envia el correo electronico, llama al serivico de sendgrid
   */
  const response = await sendMail(json);
  if (response.status === 200) {
    // trace.information(`email enviado ${json}`);
  } else {
    toast.isToastOpen = true;
    toast.msgToast = "Error, email de notificación fallo";
    toast.typeStyle = "error";
  }

  // Realiza envio de SMS con link de activacion al cliente
  // sendSMSActivationAccount(datosSMSMesssage);
};

export const sendNotificationApp = (json) => async (dispatch) => {
  const toast = {};
  const response = await sendMail(json);
  if (response.status === 200) {
    // trace.information(`email enviado ${json}`);
  } else {
    toast.isToastOpen = true;
    toast.msgToast = "Error, email de notificación fallo";
    toast.typeStyle = "error";
  }
};
